<template>
    <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-5 p-5 bg-light">
        <img src="@/assets/img/logos/mcafee-escudo.svg" alt="icone da logo da McAfee">
        <p class="h3 fw-light"><b class="fw-bold">Milhares de clientes</b> compram, jogam e navegam <br /> online com segurança. <b class="fw-bold">Seja um deles!</b></p>
    </div>
</template>
